/**
 * Test booking the July 30 course
 */

import { createBooking } from '../services/bookingService';
import { getCourseById } from '../services/courseService';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function testJulyBooking() {
  const JULY_COURSE_ID = '296faed7-a5f5-4c1f-9e1b-38dd3623c4a0';
  
  console.log('🔍 TESTING JULY 30 COURSE BOOKING');
  console.log('=' .repeat(50));
  
  try {
    // Get user info
    const session = await fetchAuthSession();
    const token = session.tokens.idToken.toString();
    const tokenParts = token.split('.');
    const payload = JSON.parse(atob(tokenParts[1]));
    const userEmail = payload.email;
    const groups = payload['cognito:groups'] || [];
    
    console.log('\n👤 CURRENT USER:');
    console.log('Email:', userEmail);
    console.log('Groups:', groups);
    console.log('Primary Group:', groups[0]);
    
    // Get course details
    console.log('\n📚 FETCHING JULY COURSE...');
    const course = await getCourseById(JULY_COURSE_ID);
    console.log('Course title:', course.title);
    console.log('Course status:', course.status);
    console.log('Available spots:', course.availableSpots);
    console.log('Total spots:', course.totalSpots);
    console.log('Course ID:', course.courseId || course.id);
    
    // Test 1: Minimal booking
    console.log('\n🎯 TEST 1: Minimal booking (just courseId)...');
    try {
      const booking1 = await createBooking({
        courseId: JULY_COURSE_ID
      });
      console.log('✅ SUCCESS! Booking created:', booking1);
      return booking1;
    } catch (err) {
      console.log('❌ FAILED:', err.message || err);
      if (err.response) {
        console.log('Response:', err.response);
      }
      
      // Try to parse error details
      if (err && err.message) {
        try {
          const errorData = JSON.parse(err.message);
          console.log('Parsed error:', errorData);
        } catch (e) {
          // Not JSON
        }
      }
    }
    
    // Test 2: With payment type
    console.log('\n🎯 TEST 2: Booking with payment type...');
    try {
      const booking2 = await createBooking({
        courseId: JULY_COURSE_ID,
        paymentType: { type: 'deposit' }
      });
      console.log('✅ SUCCESS! Booking created:', booking2);
      return booking2;
    } catch (err) {
      console.log('❌ FAILED:', err.message || err);
    }
    
    // Test 3: With student name (Students shouldn't need this)
    console.log('\n🎯 TEST 3: Booking with student name...');
    try {
      const booking3 = await createBooking({
        courseId: JULY_COURSE_ID,
        studentName: 'Test Student',
        paymentType: { type: 'deposit' }
      });
      console.log('✅ SUCCESS! Booking created:', booking3);
      return booking3;
    } catch (err) {
      console.log('❌ FAILED:', err.message || err);
    }
    
    // Test 4: Check if it's a duplicate booking issue
    console.log('\n🔍 POSSIBLE ISSUES:');
    console.log('1. You might already have a booking for this course');
    console.log('2. You might have an active reservation that hasn\'t expired');
    console.log('3. The course might require specific payment types');
    console.log('4. There might be email restrictions on the course');
    
  } catch (error) {
    console.error('Test failed:', error);
  }
}

window.testJulyBooking = testJulyBooking;